



















































































import { ciCheckCircle } from '~/icons/source/solid/check-circle'
import { ciTimesCircle } from '~/icons/source/solid/times-circle'
import { AutoTouchStatus } from '~/models/auto-touch/types'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  props: {
    autoTouchData: { type: Object, required: true },
    grayIcons: { type: Boolean, default: false },
    withoutLabel: { type: Boolean, default: false }
  },
  computed: {
    autoTouchStatus(): AutoTouchStatus {
      return AutoTouchStatus
    },
    icons(): object {
      return {
        [AutoTouchStatus.TOUCH_SUCCESS]: ciCheckCircle,
        [AutoTouchStatus.TOUCH_FAIL]: ciTimesCircle
      }
    }
  }
})
